import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { TokenService } from './token.service';
import { ApiService } from './apiservice';
import { District } from '../app/interfaces/District';
import { DistrictDispatchData } from '../app/interfaces/DistrictDispatchData'
import { AdminDistrictOrder } from '../app/interfaces/AdminDistrictOrder';

@Injectable({
  providedIn: 'root'
})
export class DistrictService {
  url: string;
  urlUserFilter: string;
  apiToken: string = "";
  userId: string = "";
  userObject: any;

  constructor(private http: HttpClient, private tokenService: TokenService, private apiService: ApiService) {
    this.url = environment.apiConfig.apiPath;
    this.urlUserFilter = environment.apiConfig.uri + environment.apiConfig.userIdFilter;

  }

  public getUser() {
    return this.apiService.getUser();
  }

  getDistricts(groupId:any): Observable<District[]> {
    return this.apiService.get(this.url + `api/District/GetDistrictData/${groupId}`);
  }


  getDistrictDetails(payload: any) {
    return this.apiService.post(this.url + `api/DispatchView/district/DispatchViewData`, payload);
  }

  
   



}
